import { useTableMode } from '@Hooks/useTableModes';
import { type UseOrderTableModes, useOrderTableModes } from './useOrderTableModes';
import { FrameListStagedOrders } from './FrameListStagedOrders';
import { FrameListOrders } from './FrameListOrders';

export function FrameListOrder() {
    const listOrderTableModes = useOrderTableModes();
    const tableModeProps = useTableMode<UseOrderTableModes>('main', listOrderTableModes);

    if (tableModeProps.tableModeValue === 'staging') {
        return <FrameListStagedOrders {...tableModeProps} />;
    } else {
        return <FrameListOrders {...tableModeProps} />;
    }
}
